<template>
  <footer class="footer-simple row">
    <div class="column copyright">
      {{ currentYear }} <br />
      ALL <br />
      RIGHTS <br />
      RESERVED <br />
      ©
    </div>
    <div class="column text-left medium-text-center">
      <a href="https://grupazywiec.pl/polityka-cookies/" target="_blank" class="link">
        Polityka Cookies
      </a>
      <a href="#cookie-settings" class="link">
        Ustawienia cookies
      </a>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterSimple',
  computed: {
    currentYear() {
      return new Date().getFullYear()
    }
  }
}
</script>

<style lang="scss" scoped>
.footer-simple {
  width: 100%;
  z-index: z(footer);
  align-items: center;

  border-top: 1px solid #352d21;
  padding: 2rem 0;
}

.copyright {
  font-size: 0.5675rem;
}

::v-deep button,
.link {
  display: inline-block;
  color: #ffffff;
  text-decoration: none;
  text-transform: uppercase;
  font-weight: 900;
  padding: 0 1rem;
  transition: all 0.4s;
  transform: none;
  cursor: pointer;

  @include media-down(md) {
    font-size: 0.6rem;
  }

  &:focus {
    color: #ffffff;
  }

  &:hover {
    transform: translateY(-8px) scale(1.15);
    color: #ffffff;

    @include media-down(md) {
      transform: translateY(-6px) scale(1.1);
    }
  }
}
</style>
